import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/regulation/Cayman.webp")